<template>
  <main-layout wide>
    <div class="client-show__grid">
      <div class="col-left">
        <client-information-container />
      </div>
      <div class="col-center">
        <client-spend-container v-if="isIntegrated && responsive.lg" />
        <client-activity-container />
        <client-history-container />
      </div>
    </div>
  </main-layout>
</template>
<script>

import Integrable from '@/components/mixins/integrable';
import ClientActivityContainer from '@/components/Widgets/ClientActivityContainer';
import ClientSpendContainer from '@/components/Widgets/ClientSpendContainer';
import ClientHistoryContainer from '@/components/Widgets/ClientHistoryContainer';
import ClientInformationContainer from '@/components/Widgets/ClientInformationContainer';
import responsive from '@/components/mixins/responsive';

export default {
  name: 'AssociateClientShow',
  components: {
    ClientActivityContainer,
    ClientSpendContainer,
    ClientInformationContainer,
    ClientHistoryContainer,
  },
  mixins: [Integrable, responsive],
  data() {
    return {};
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
  },
  mounted() {
    this.$store.dispatch('customers/fetchItem', {
      id: this.customerId,
      scope: this.$store.getters['account/scope'],
      includeSpend: true,
    });
  },
};
</script>

<style lang="scss" scoped>
.client-show__grid{
  display: grid;
  grid-template-columns: 210px 1fr;
  column-gap: 14px;
  @media screen and (min-width: map-get($breakpoints,'lg')){
    grid-template-columns: 265px 1fr;
  }
}

// $col-width: 220px;
// .col-left{
//   width: 100%;
//   max-width: $col-width;
//   @media screen and (min-width: 1055px){
//     max-width: 265px;
//   }
// }
// .col-center{
//   width: 100%;
//   margin-left: $grid-gutter-width;
// }
</style>
